export default __webpack_public_path__ + "static/media/tuatRed.ee04e730.svg";